import React from 'react';
import { Divider, Stack } from '@mui/material';

import { FloorPolyline3D } from '@paragon/contract-library';
import { distanceLessThanOrEqual } from '@paragon/geometry-library';
import { DistanceField } from '@paragon/material';

import { FeaturePatternContainerGeometryField } from './FeaturePatternContainerGeometryField';

interface Props {
  readonly value: FloorPolyline3D;
  readonly onChange: (value: FloorPolyline3D) => void;
  readonly disabled?: boolean;
}

export function FeaturePatternContainerShapeControls({ value, onChange, disabled }: Props) {
  const depth = value.topElevation - value.bottomElevation;

  return (
    <>
      <Stack direction="row" spacing={1}>
        <DistanceField
          label="Bottom Elevation"
          value={value.bottomElevation}
          validator={(bottomElevation) => {
            if (distanceLessThanOrEqual(value.topElevation, bottomElevation)) {
              return 'Must be below top elevation';
            }
          }}
          onSubmit={(bottomElevation) => {
            onChange({ ...value, bottomElevation });
          }}
          disabled={disabled}
        />

        <DistanceField
          label="Depth"
          value={depth}
          validator={(newDepth) => {
            if (distanceLessThanOrEqual(newDepth, 0)) {
              return 'Must be greater than 0';
            }
          }}
          onSubmit={(newDepth) => {
            onChange({ ...value, topElevation: value.bottomElevation + newDepth });
          }}
          disabled={disabled}
        />

        <DistanceField
          label="Top Elevation"
          value={value.topElevation}
          validator={(topElevation) => {
            if (distanceLessThanOrEqual(topElevation, value.bottomElevation)) {
              return 'Must be above bottom elevation';
            }
          }}
          onSubmit={(topElevation) => {
            onChange({ ...value, topElevation });
          }}
          disabled={disabled}
        />
      </Stack>

      <Divider />

      <FeaturePatternContainerGeometryField value={value} disabled={disabled} />
    </>
  );
}
